// import { sizes } from '../GlobalStyles';
import styled from 'styled-components';

export const Figure = styled.figure`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 320px;
    width: 100%;
    background: #0046d1;
    margin: 0;
    border-radius: 0 8px 0 0;
    position: relative;
    overflow: hidden;
    &:after {
        content: '';
        border-color: transparent transparent #e8e9ea transparent;
        border-style: solid;
        border-width: 0 0 30vw 100vw;
        bottom: 0;
        height: 0;
        position: absolute;
        left: 0;
        width: 0;
    }
`;

export const Photo = styled.img`
    object-fit: cover;
    object-position: center center;
    width: 100%;
    height: 100%;
    border-radius: 0 8px 0 0;
`;

export const FigureCation = styled.figcaption`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    background-color: #fff;
    border-radius: 50%;
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;

    img {
        width: 48px;
    }
`;

export const Avatar = styled.img`
    height: 48px;
    width: 48px;
`;
